var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#3f8ad1;}.cls-3{fill:#3475ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1336",
    "data-name": "Ellisse 1336"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 12.5,
    r: 12.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.52,12.52,0,0,1,12.5,25ZM12.5.92A11.58,11.58,0,1,0,24.08,12.5,11.59,11.59,0,0,0,12.5.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.34,16.17l-2-1a.43.43,0,0,0-.51.1l-1.52,1.49a14.75,14.75,0,0,1-3.69-2.44A11.06,11.06,0,0,1,8.59,11c.79-.72,1.84-1.76,1.84-1.76a.52.52,0,0,0,.08-.59L9.32,6.4a.48.48,0,0,0-.57-.23l-2,.71a.48.48,0,0,0-.31.52c0,.15,0,.31.05.46h0s0,.22.1.55A6.23,6.23,0,0,0,6.73,9a14.75,14.75,0,0,0,.53,1.67,13.15,13.15,0,0,0,2.59,4.42,16.49,16.49,0,0,0,4.89,3.05,8.22,8.22,0,0,0,2.81.68.43.43,0,0,0,.45-.31l.56-1.85A.44.44,0,0,0,18.34,16.17Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.2d69e61c14f104457c329d767fd192d9.svg";
export { ForwardRef as ReactComponent };